export const TENDER_CODE = {
  UNKNOWN: 'UNBEKANNT',
};
